import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import { MGSiteButton } from "mgUiKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'PageTicketsListComponent';

class TicketsList extends React.Component {
    constructor(props, context) {
        super(props);
        this.openPage = this.openPage.bind(this);
    }
    
    openPage(){
        this.context.openTicketsList();
    }

    render(){
        return(       
        <div className="mg-user-widget-inside"> 
            <MGSiteButton
                title="Le tue giocate"                 
                class=""
                label="Le tue giocate"
                disabled={false}
                primary={false}
                isButton={false}
                fullWidth={true}
                actionFunc={this.openPage}
            />
            </div>
                
        )
    }
}

TicketsList.displayName = componentName;

// PropTypes validation
TicketsList.propTypes = {
};

// default props
TicketsList.defaultProps = {
};

TicketsList.contextTypes = {
    handleSetPage: PropTypes.func,
    openTicketsList: PropTypes.func
}

export default  TicketsList;